import { actionTypesSimple } from "./BookTable.actionTypes";

/**
 *
 * @typedef {{
 *  name: string,
 *  latitude: number,
 *  longitude: number
 * }} CityLatLong
 */

/**
 *
 * @param {CityLatLong[]} cities
 */
export const setCities = cities => ({
  type: actionTypesSimple.SET_CITIES,
  payload: cities
});

/**
 *
 * @typedef {{
 *  ls_store_id: string,
 *  name: string,
 *  status: status,
 *  frontend_name: string,
 *  latitude,
 *  longitude,
 *  store_preview_image_mobile,
 *  store_preview_image_desktop,
 *  address: {
 *      address1: string,
 *      address2,
 *      city: string,
 *      phone_number: string,
 *      region
 *  },
 *  store_hours: {
 *      day,
 *      from,
 *      to,
 *      type
 *  }[]
 * }} StoreFullData
 */

/**
 *
 * @param {StoreFullData[]} stores
 */
export const setStoresFull = stores => ({
  type: actionTypesSimple.SET_STORES_FULL,
  payload: stores
});

/**
 *
 * @param {StoreFullData} store
 */
export const setSelectedStore = store => ({
  type: actionTypesSimple.SET_SELECTED_STORE,
  payload: store
});

/**
 *
 * @param {StoreFullData} store
 */
export const setPreviousBookings = store => ({
  type: actionTypesSimple.SET_PREVIOUS_BOOKINGS,
  payload: store
});

/**
 *
 * @param {StoreFullData} store
 */
export const setPreviouValues = values => ({
  type: actionTypesSimple.SET_PREVIOUS_VALUES,
  payload: values
});

/**
 *
 * @param {string} contactId
 */
export const setContactId = contactId => ({
  type: actionTypesSimple.SET_CONTACT_ID,
  payload: contactId
});

/**
 *
 * @param {boolean} willBeOpen
 */
export const setModalBookATableOpen = willBeOpen => ({
  type: actionTypesSimple.SET_MODAL_OPEN,
  payload: !!willBeOpen
});

/**
 *
 * @param {boolean} willBeOpen
 */
export const setModalFeedbackBookingEditOpen = willBeOpen => ({
  type: actionTypesSimple.SET_MODAL_OPEN,
  payload: !!willBeOpen
});

/**
 *
 * @param {boolean} isEditFlow
 */
export const setIsEditFlow = isEditFlow => ({
  type: actionTypesSimple.SET_IS_EDIT_FLOW,
  payload: !!isEditFlow
});

/**
 *
 * @param {boolean} isFavRestaurantSelected
 */
export const setIsFavRestaurantSelected = isFavRestaurantSelected => ({
  type: actionTypesSimple.SET_FAV_RESTAURANT_SELECTED,
  payload: !!isFavRestaurantSelected
});

/**
 *
 * @param {boolean} FavRestaurantData
 */
export const setFavRestaurant = FavRestaurantData => ({
  type: actionTypesSimple.SET_FAV_RESTAURANT,
  payload: FavRestaurantData
});
export const setCancelBookingError = error => ({
  type: actionTypesSimple.SET_CANCEL_BOOKING_ERROR,
  payload: error
});
export const resetBook_a_Table = () => ({
  type: actionTypesSimple.RESET_BOOK_A_TABLE,
  payload: null
});